/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useEffect, useState, Fragment} from "react";
import {service as UserService} from "../../../../../Services/UserService";
import {useMakePageRequest} from "../../../../../Hooks/RequestHooks";
import DateUtils from "../../../../../../../monitoring/src/Utils/DateUtils";
import {useEffectPromise} from "../../../../../Hooks/EffectHooks";
import {UserFieldViewer} from "../../../../../Models/Core/ServiceDrivenViewers";

export const LastModifiedSpeciesLabel = function (props) {

    const {data} = props;
    const [lastModifiedSpecies, setLastModifiedSpecies] = useState(null);

    useEffect(() => {
        if (data?.length) {
            data.sort((a, b) => new Date(b.modified) - new Date(a.modified));
            const mostRecentItem = data[0];
            setLastModifiedSpecies(mostRecentItem);
        }
    }, [data]);

    const lastModifiedUserId = lastModifiedSpecies?.modifiedByUserId ?? null;

    const getText = () => {
        if (!data?.length || !lastModifiedSpecies?.modifiedByUserId) return null;

        return <div className="sb-last-modified-statement">
            <span>Last Modified at </span>
            <a className="link-primary"
               style={{textDecoration: 'underline'}}
               onClick={() => props.onDateClick(lastModifiedSpecies.speciesId)}>
                {DateUtils.FormatToLocalDate(lastModifiedSpecies.modified, 'MM/dd/YYY h:mm a')}
            </a>
            {
                !!lastModifiedUserId &&
                [
                    " by ",
                    <UserFieldViewer Value={lastModifiedUserId} />,
                ]
            }
        </div>
    };

    return <div className="sb-table-filter-supplement">{getText()}</div>
};
